var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRectsWithDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 3.125V5.625H3.75V11.875H3.125V14.375H5.625V13.75H6.875V15H6.25V17.5H8.75V16.875H15V17.5H17.5V15H16.875V8.75H17.5V6.25H15V6.875H13.75V5.625H14.375V3.125H11.875V3.75H5.625V3.125H3.125ZM5.625 5H11.875V5.625H12.5V11.875H11.875V12.5H5.625V11.875H5V5.625H5.625V5ZM13.75 8.125H15V8.75H15.625V15H15V15.625H8.75V15H8.125V13.75H11.875V14.375H14.375V11.875H13.75V8.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRectsWithDots);
export default ForwardRef;